var VideoPlayerModule = (function () {
    function VideoPlayerModule() {
    }
    return VideoPlayerModule;
}());
export { VideoPlayerModule };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/video-player/video-player.module.ts.pre-build-optimizer.js